(function () {
  'use strict';

  angular.module('directives.latin1FormValidation', []);
})();
